window.tracking = {}

window.tracking.ga4 = {
    measurementId: 'G-KX89BBCDCX',

    getCookieValue: function(name) {
        return window.utils.cookies.getCookieValue(name);
    },

    getClientIdFromCookie: function() {
        const gaCookie = this.getCookieValue('_ga');

        if (!gaCookie) {
            return null;
        }

        const parts = gaCookie.split('.');

        if (parts.length < 4) {
            return null;
        }

        return parts.slice(-2).join('.');
    },

    getSessionIdFromCookie: function() {
        const measurementCookieName = '_ga_' + this.measurementId.replace(/^G-/, '');
        const sessionCookie = this.getCookieValue(measurementCookieName);

        if (!sessionCookie) {
            return null;
        }

        const oldFormatMatch = sessionCookie.match(/^GS\d+\.\d+\.(\d+)/);

        if (oldFormatMatch && oldFormatMatch[1]) {
            return oldFormatMatch[1];
        }

        const newFormatMatch = sessionCookie.match(/(?:^|[$.])s(\d+)/);

        if (newFormatMatch && newFormatMatch[1]) {
            return newFormatMatch[1];
        }

        return null;
    },

    getIdentifiersFromGtag: function() {
        return new Promise((resolve) => {
            if (typeof window.gtag !== 'function') {
                resolve(null);
                return;
            }

            let clientId = null;
            let sessionId = null;
            let clientIdComplete = false;
            let sessionIdComplete = false;
            let resolved = false;
            let timeout = null;

            const safeResolve = function(value) {
                if (resolved) {
                    return;
                }

                resolved = true;
                clearTimeout(timeout);
                resolve(value);
            };

            const finish = function() {
                if (!clientIdComplete || !sessionIdComplete) {
                    return;
                }

                safeResolve({
                    client_id: clientId,
                    ga_session_id: sessionId,
                });
            };

            timeout = setTimeout(function() {
                safeResolve(null);
            }, 500);

            window.gtag('get', window.tracking.ga4.measurementId, 'client_id', function(value) {
                clientId = value || null;
                clientIdComplete = true;
                finish();
            });

            window.gtag('get', window.tracking.ga4.measurementId, 'session_id', function(value) {
                sessionId = value || null;
                sessionIdComplete = true;
                finish();
            });
        });
    },

    getIdentifiers: async function() {
        const identifiersFromGtag = await this.getIdentifiersFromGtag();
        const clientId = identifiersFromGtag?.client_id || this.getClientIdFromCookie();
        const sessionId = identifiersFromGtag?.ga_session_id || this.getSessionIdFromCookie();

        if (clientId || sessionId) {
            return {
                client_id: clientId,
                ga_session_id: sessionId,
            };
        }

        return null;
    }
}
